import { render, staticRenderFns } from "./SubOrdersMain.vue?vue&type=template&id=b0590816&scoped=true&"
import script from "./SubOrdersMain.vue?vue&type=script&lang=js&"
export * from "./SubOrdersMain.vue?vue&type=script&lang=js&"
import style0 from "./SubOrdersMain.vue?vue&type=style&index=0&id=b0590816&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0590816",
  null
  
)

/* custom blocks */
import block0 from "./SubOrdersMain.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports